import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { IconDesktop, IconBackArrow } from "icons";
import Button from "components/Button";
import { PATHS } from "router/config/paths";

const MobileWarning = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  // Universal back: step through history when possible, otherwise fall back to Home.
  const handleBack = () => {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate(PATHS.HOME);
    }
  };

  return (
    <div data-testid="mobile-warning" className="p-10 flex-center flex-1">
      <div className="flex flex-center flex-col gap-5 w-[300px] text-center">
        <div className="flex-center w-16 h-16 rounded-full bg-black-200 text-grey">
          <IconDesktop className="w-7 h-7" />
        </div>
        <div className="flex flex-col gap-2">
          <h5 className="text-h5 text-trueBlack dark:text-white">{t("common:mobile_warning.title")}</h5>
          <p className="text-bodyMd text-grey">{t("common:mobile_warning.body")}</p>
        </div>
        <Button className="btn-secondary-small" onClick={handleBack}>
          <IconBackArrow className="w-[18px] h-[18px]" />
          {t("common:mobile_warning.back")}
        </Button>
      </div>
    </div>
  );
};

export default MobileWarning;
